var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(" Sales Chart ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('im-bar-chart',{attrs:{"chart-data":_vm.chart_data,"options":_vm.chart_options,"height":250}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }